import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Logger, LoggerFactory } from '../logger.service';
import { CurrentContextService } from '../current-context.service';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { AccountUpgradePopupService } from '../../account-upgrade/account-upgrade-popup/account-upgrade-popup.service';

@Injectable()
export class TierAccountGuard {
  private readonly logger: Logger;
  constructor(
    loggerFactory: LoggerFactory,
    protected readonly router: Router,
    private readonly currentContextService: CurrentContextService,
    private accountUpgradePopupService: AccountUpgradePopupService,
  ) {
    this.logger = loggerFactory.get('TierAccountGuard');
  }

  public canActivate(ars: ActivatedRouteSnapshot): Observable<boolean> {
    const access = ars.data.access;
    return this.currentContextService.currentContextBS.pipe(
      filter((currentContext) => !!currentContext),
      map((currentContext) => {
        const tierAccess = currentContext.tierAccess;
        let isAllowed = true;

        if (access === 'visits' && !tierAccess?.isVisitsAllowed) {
          isAllowed = false;
        } else if (access === 'profiles' && !tierAccess?.isProfilesAllowed) {
          isAllowed = false;
        } else if (access === 'referral' && !tierAccess?.isReferralsAllowed) {
          isAllowed = false;
        } else if (access === 'automations' && !tierAccess?.isAutomationsAllowed) {
          isAllowed = false;
        } else if (access === 'coupons' && !tierAccess?.isCouponsAllowed) {
          isAllowed = false;
        } else if (access === 'sales' && !tierAccess?.isSalesAnalyticsAllowed) {
          isAllowed = false;
        } else if (access === 'interest-profiles' && !tierAccess?.isInterestProfilesAllowed) {
          isAllowed = false;
        } else if (access === 'performance' && !tierAccess?.isPerformanceAnalyticsAllowed) {
          isAllowed = false;
        } else if (access === 'activity-log' && !tierAccess?.isActivityLogAllowed) {
          isAllowed = false;
        } else if (access === 'logged-in-detection' && !tierAccess?.isLoggedInDetectionAllowed) {
          isAllowed = false;
        }

        if (!isAllowed) {
          this.denyAccess(access);
          return false;
        }

        return true;
      }),
      take(1),
    );
  }

  private denyAccess(access: string) {
    this.accountUpgradePopupService.openPopup(access);
    this.goToDashboardIfNothingIsLoaded();
  }

  private goToDashboardIfNothingIsLoaded() {
    if (this.router.routerState.snapshot.root.firstChild?.component !== null) {
      this.router.navigate(['/']);
    }
  }
}
